var C = Object.defineProperty;
var c = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, h = Object.prototype.propertyIsEnumerable;
var f = (r, e, o) => e in r ? C(r, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : r[e] = o, m = (r, e) => {
  for (var o in e || (e = {}))
    d.call(e, o) && f(r, o, e[o]);
  if (c)
    for (var o of c(e))
      h.call(e, o) && f(r, o, e[o]);
  return r;
};
var g = (r, e) => {
  var o = {};
  for (var s in r)
    d.call(r, s) && e.indexOf(s) < 0 && (o[s] = r[s]);
  if (r != null && c)
    for (var s of c(r))
      e.indexOf(s) < 0 && h.call(r, s) && (o[s] = r[s]);
  return o;
};
import { jsx as v } from "react/jsx-runtime";
import { escapeRegExp as R } from "./HighlightHelpers.js";
import { p as S, f as $, u as w, B as N, b as T } from "../../factory-ueRxoNOV.js";
import "react";
import { c as B } from "../../create-vars-resolver-Bzbn9G-G.js";
import { u as E } from "../../use-styles-DToiHEa6.js";
function k({ color: r, theme: e, defaultShade: o }) {
  const s = S({ color: r, theme: e });
  return s.isThemeColor ? s.shade === void 0 ? `var(--mantine-color-${s.color}-${o})` : `var(${s.variable})` : r;
}
var y = { root: "m_bcb3f3c2" };
const P = {
  color: "yellow"
}, j = B((r, { color: e }) => ({
  root: {
    "--mark-bg-dark": k({ color: e, theme: r, defaultShade: 5 }),
    "--mark-bg-light": k({ color: e, theme: r, defaultShade: 2 })
  }
})), p = $((r, e) => {
  const o = w("Mark", P, r), u = o, { classNames: s, className: a, style: l, styles: i, unstyled: t, vars: n, color: H, variant: M } = u, b = g(u, ["classNames", "className", "style", "styles", "unstyled", "vars", "color", "variant"]), x = E({
    name: "Mark",
    props: o,
    className: a,
    style: l,
    classes: y,
    classNames: s,
    styles: i,
    unstyled: t,
    vars: n,
    varsResolver: j
  });
  return /* @__PURE__ */ v(N, m(m({ component: "mark", ref: e, variant: M }, x("root")), b));
});
p.classes = y;
p.displayName = "@mantine/core/Mark";
const F = ({ highlight: r = "", highlightColor: e, text: o = "", textColor: s }) => {
  const a = T();
  if (!r.trim())
    return o;
  const l = new RegExp(`(${R(r)})`, "gi"), i = (t, n) => l.test(t) ? /* @__PURE__ */ v(
    p,
    {
      color: e || a.colors[a.primaryColor][7],
      style: { color: s || a.white },
      "data-highlighted": !0,
      children: t
    },
    n
  ) : t;
  return o.split(l).filter((t) => t).map((t, n) => i(t, n));
};
export {
  F as Highlight
};
